import React from "react";
import ReactDOM from "react-dom/client";
import "./global.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { RendererJSON } from "./pages/CMSRenderer/renderer";
import {
  AboutPublicHealth,
  ABOUTUS,
  AnnualHealthStatisticBook,
  Circular_static_with_api,
  CommitmentStatement,
  CommunityEngagementProgrammes,
  CustomerHappinessCharater,
  DHASurveys,
  DrugControl,
  DubaiChallenge,
  FAQ_static_with_api, //fixed
  GovermentInsuranceServices,
  HealthInsurance,
  HealthInsurancePermitServices,
  HealthLicensing,
  HealthRegulation,
  HealthSector,
  HealthTourism,
  Home_static_with_api,
  InvestingHealthCareCenter,
  ISAHD,
  MediaCenter,
  MedialResearch,
  MedicalEducation, //fixed
  MedicalEducationandResearch,
  MedicalInDubai,
  MedicalLibrary,
  MedicalRegistry,
  MedicalResearch,
  MedicalTraining,
  OccupationHealth,
  OurLeaders,
  ProgrammesAndPublishedArticles,
  ProjectInitiatives,
  promotionAwareness_static_with_api,
  PublicHealth,
  RegulartoryDocuments_static_with_api,
  search_static_with_api,
  SiteMap,
  SpecialProgrammes,
  TermsAndCondition,
  TrainingFacility,
  WellnessInDubai,
  richtext_editor,
  AnnualHealthStatisticBook2,
  Services_static_with_api,
  OverviewHealthInDubai_static_with_api,
} from "./pages/CMSRenderer/dataJSON";
import RendererJSONSSS from "./pages/CMSRenderer/renderer";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
// window.addEventListener("message", (event) => {
//   console.log("event", event);

//   // IMPORTANT: verify message origin for security
//   if (event.origin !== "http://localhost:5173") return;

//   if (event.data?.type === "renderCMS") {
//     window.renderCMS({
//       JSONDATA: event.data.JSONDATA,
//       DIVID: event.data.DIVID,
//     });
//   }
// });

window.renderCMS = ({ JSONDATA, DIVID, LANGUAGE }) => {
  const root = ReactDOM.createRoot(document.getElementById(DIVID || "root"));
  const RendererJSON = JSONDATA !== undefined ? JSONDATA : {"breadcrumbs":[],"id":1173,"dguid":"f8682a49-474f-4652-94ad-1701b7f7b994","parent":null,"titleEn":"Services","titleAr":"الخدمات","content":null,"slug":"services","layout":"default","status":"published","metaTitleEn":"Services","metaDescriptionEn":"These are DHA services for individuals, tourists, residents or citizens of the United Arab Emirates.","metaKeywordsEn":"services,dha","metaTitleAr":"الخدمات","metaDescriptionAr":"خدمات هيئة الصحة بدبي للأفراد والسياح والمقيمين ومواطني دولة الإمارات العربية المتحدة.","metaKeywordsAr":"services,dha","seoImageUrl":"","javascript":"","css":"","createdBy":"system","updatedBy":"system","deployed":false,"createdAt":"2026-07-13T07:38:38.747Z","updatedAt":"2026-07-13T07:45:56.322Z","blocks":[{"_id":"component_e5ecf5fb-6058-444e-a2f6-f9a12ae41973","type":"div","classname":"","children":[{"_id":"f8f88ba2-505c-48d3-969a-49eb26863aeb","type":"dda-breadcrumb","breadCrumb_item":[{"text":"Home","icon":"home","url":"/","text_ar":"الرئيسية"},{"text":"Services","icon":"menu_book","url":"/services","text_ar":"الخدمات"}]},{"_id":"component_4a64f48a-8a18-44c5-98fc-fc9389864d00","type":"static_services","props":{"hero_image":"/attachments/medialib/46f2d4b7-4eab-4d93-81dd-82b5e188ef51-1781344334128-673700437-5_Services.jpg","title":"Our Services","title_ar":"خدماتنا","all_service":"All Services","all_service_ar":"جميع الخدمات","sidebar_title":"Categories","sidebar_title_ar":"الفئات","search_input_placeholder":"Find a service","search_input_placeholder_ar":"ابحث عن خدمة","select_input_placeholder":"Sort by A-Z","select_input_placeholder_ar":"الترتيب من الألف إلى الياء","service_count_text":"Showing $count Services","service_count_text_ar":"عرض $count خدمة","no_search_results_text":"No results found for your search.","no_search_results_text_ar":"لم يتم العثور على نتائج لبحثك.","no_services_text":"No services found","no_services_text_ar":"لم يتم العثور على خدمات."}}]}]};
  root.render(
    <React.StrictMode>
      <App JSONDATA={RendererJSON} LANGUAGE={LANGUAGE} />
    </React.StrictMode>
  );
};
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
